import { render, staticRenderFns } from "./document-sidenav.vue?vue&type=template&id=64d5a548&scoped=true&"
import script from "./document-sidenav.vue?vue&type=script&lang=js&"
export * from "./document-sidenav.vue?vue&type=script&lang=js&"
import style0 from "./document-sidenav.vue?vue&type=style&index=0&id=64d5a548&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d5a548",
  null
  
)

component.options.__file = "document-sidenav.vue"
export default component.exports